import {LitElement, html} from "lit";
import { customElement, state } from "lit/decorators.js";
import '@/components/cookie-overlay/cookie-overlay';
import { style } from './datawrapper.styles';
import CookieLayer from "@/components/cookie-layer/cookie-layer.ts";

@customElement('sbk-datawrapper')
export class Datawrapper extends LitElement {

    @state()
    cookiesAccepted: boolean;

    static get styles() {
        return style;
    }

    constructor() {
        super();
        this.cookiesAccepted = CookieLayer.isCookieConsentLoaded();
    }

    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('third-party-cookies-accepted', this._onCookiesAccepted);
    }
    disconnectedCallback() {
        document.removeEventListener('third-party-cookies-accepted', this._onCookiesAccepted);
        super.disconnectedCallback();
    }

    render() {
        return html`<div class="wrapper">
            ${this.cookiesAccepted ? html`<slot name="datawrapper" @slotchange=${this.handleChange}></slot>` : html`<sbk-cookie-overlay></sbk-cookie-overlay>`}
        </div>`;
    }

    handleChange() {
        const observedNodes = new Set();
        const targetParent = this.querySelector('div[slot="datawrapper"]');

        if (targetParent) {
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach((node) => {
                            if ((node as Element).tagName.startsWith('DATAWRAPPER-VISUALIZATION')) {
                                if (!observedNodes.has(node)) {
                                    this.injectStyles((node as HTMLElement).shadowRoot);
                                    observedNodes.add(node);
                                }
                            }
                        });
                    }
                }
            });

            observer.observe(targetParent, { childList: true, subtree: true });
        }
    }

    _onCookiesAccepted = () => {
        this.cookiesAccepted = true;
    }

    injectStyles(shadowRoot: ShadowRoot | null) {
        if (shadowRoot) {
            const styleElement = document.createElement('style');
            styleElement.className = 'sbk'
            styleElement.textContent = `
                div {
                    font-family: var(--sbkCoreFontFamily) !important;
                    color: var(--sbkColorContentFgColorOnLightDefault) !important;
                }
                h3 {
                    color: var(--sbkColorContentFgColorOnLightDefault) !important;
                }
                p.block-description, .legend {
                    color: var(--sbkColorContentFgColorOnLightDefault);
                    font-family: var(--sbkCoreFontFamily);
                    font: var(--sbkTypographyContentSmallScrBodyRegularMd);
                    font-weight: var(--sbkCoreFontWeightNormal);
                    -moz-osx-font-smoothing: grayscale;
                    -webkit-font-smoothing: antialiased;
                }

                .label {
                    color: var(--sbkColorContentFgColorOnLightDefault);
                    font-family: var(--sbkCoreFontFamily);
                    font: var(--sbkTypographyContentSmallScrBodyRegularXs);
                    @media all and (min-width: 992px) {
                        font: var(--sbkTypographyContentLargeScrBodyRegularSm);
                    }
                }
            `;
            if (!shadowRoot.querySelector('.sbk')) {
                shadowRoot.appendChild(styleElement);
            }
        }
    }
}